import { Injectable } from '@angular/core';
import {
  postSignIn,
  googlePostLogin,
  forgetpassword,
  verifyOtp,
  newForgetpassword,
  logoutApi,
} from '../../shared/const';
import { login } from '../models/login';
import { forgotPassword } from '../models/forgotPassword';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { DecryptionService } from '../../shared/services/decryption.service';
import { ProfileService } from '../../shared/services/profile.service';
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  isloginUser = new BehaviorSubject<boolean>(false);
  private loggedIn = new BehaviorSubject<boolean>(false);
  private formDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  public id: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private inLoginProcess: boolean = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private decryptionApi: DecryptionService,
    private profileData: ProfileService
  ) {}

  postSignIn(data: any): Observable<any> {
    return this.http.post<login[]>(`${postSignIn}`, data).pipe(
      tap((response: any) => {
        const decrypt = this.decryptionApi.decrypt(response.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.isloginUser.next(true);
        localStorage.setItem('loggedInUser', JSON.stringify(jsondecrpt));
        this.router.navigate(['home']);
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error.error.message);
      })
    );
  }

  googlePostLogin(data: any): Observable<any> {
    let idToken = { idToken: data };
    return this.http.post(`${googlePostLogin}`, idToken).pipe(
      tap((response: any) => {
        this.isloginUser.next(true);
        localStorage.setItem('loggedInUser', JSON.stringify(response.user));
        this.id.next(response.id);
        this.router.navigate(['home']);
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error.error.message);
      })
    );
  }

  setFormData(formData: any) {
    this.formDataSubject.next(formData);
  }

  login() {
    this.loggedIn.next(true);
  }

  logout() {
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('gameIdreponse');
    localStorage.removeItem('playedGame');
    this.loggedIn.next(false);
    this.router.navigate(['home']);
  }

  logoutUser() {
    return this.http.get(`${logoutApi}`);
  }

  forgetpassword(data: any): Observable<any> {
    return this.http.post(`${forgetpassword}`, data).pipe(
      tap((response: any) => {
        localStorage.setItem('email', JSON.stringify(response.email));
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error.error.message);
      })
    );
  }

  verifyOtpCode(data: any) {
    return this.http.post(`${verifyOtp}`, data).pipe(
      tap((response: any) => {
        const decrypt = this.decryptionApi.decrypt(response.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.isloginUser.next(true);
        localStorage.setItem('loggedInUser', JSON.stringify(jsondecrpt));
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error.error.message);
      })
    );
  }

  Forgetpassword(token: any, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-auth-token': token,
    });
    return this.http
      .post<forgotPassword[]>(`${newForgetpassword}`, data, {
        headers: headers,
      })
      .pipe(
        tap((response: any) => {
          this.router.navigate(['home']);
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error.error.message);
        })
      );
  }

  setLoginProcessStatus(status: boolean) {
    this.inLoginProcess = status;
  }

  isInLoginProcess(): boolean {
    return this.inLoginProcess;
  }
}
